module.exports = __webpack_public_path__ + "img/03d.162f6d35.svg";